<template>
  <div class="container-fluid m-2">
    <h2>Passwort Safe</h2>
    <div class="row mt-2">
      <div class="col-md">
        <h3>Passwörter</h3>
        <ul class="list-group">
          <li v-for="(e,index) in list" :key="e.id" class="list-group-item d-flex justify-content-between">
            <span>{{ e.key }}</span>
            <div class="btn-group">
              <button @click="editEntry(index)" class="btn btn-primary"><font-awesome-icon icon="edit"/></button>
              <button @click="deleteEntry(index)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md">
        <h3>Neuer Eintrag</h3>
        <div class="form-group">
          <label>Key</label>
          <input type="text" v-model="entry.key" class="form-control"/>
        </div>
        <div class="form-group">
          <label>Passwort</label>
          <input type="password" v-model="entry.passUpdate" class="form-control"/>
        </div>
        <div class="form-group">
          <label>Wiederholung</label>
          <input type="password" v-model="entry.passRepeat" class="form-control"/>
        </div>
        <div class="form-group">
          <label>Beschreibung</label>
          <textarea class="form-control" v-model="entry.description"></textarea>
        </div>
        <button @click="updateEntry()" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import passvault from '@/modules/passvault.js'

export default {
  data() {
    return {
      entry: {},
      list: []
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    deleteEntry(idx) {
      if (!confirm('Möchten Sie den Eintrag wirklich löschen?')) return;
      passvault.delete(this.list[idx].id);
      this.fetchData();
    },
    editEntry(idx) {
      this.entry = this.list[idx];
    },
    updateEntry() {
      var self = this;
      console.log(this.entry);
      if (this.entry.passUpdate && this.entry.passUpdate != '') {
        if (this.entry.passUpdate !== this.entry.passRepeat) {
          this.$bvModal.toast('Password repeat does not match',{title: 'Passwords', variant: 'warning'});
          return;
        }
      }
      passvault.update(this.entry).then(function(resp) {
        if (resp.status == 200) {
          self.fetchData();
        } else {
          self.$bvToast.toast('Error on update',{title: 'Passwords', variant: 'error'});
        }
      })
    },
    fetchData() {
      var self = this;
      passvault.list(0,20).then(function(resp) {
        if (resp.status == 200) {
          self.list = resp.data;
        } else {
          self.$bvToast.toast('Error on load secrets list',{title: 'Passwords', variant: 'error'})
        }
      })
    }
  }
}
</script>
